export const iconFontAwesomeWritingEnvelope = (
	<i className="fa-solid fa-envelope"></i>
);
